export default "__VITE_ASSET__CvyuhgUt__"